// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 774 ? "framework" : chunkId) + "-" + {"223":"2f7f12940827ccaa0922","231":"ce1e4c9917bac753482b","774":"b16421fb8811f0a795a6"}[chunkId] + ".js";
};